import { diffTopicGraph, TopicGraphDiff, TopicGraphNodeData } from '@arnold/core';
import { NodeData } from './dataNode';
import { CustomNodeEditor } from './rete';

type AiDiffStatus = 'added' | 'modified';

const nodeDataToTopicGraphNode = (node: NodeData): TopicGraphNodeData => ({
  questionIndex: node.questionIndex,
  questionText: node.questionText,
  isRequired: node.isRequired,
  metrics: node.metrics,
  isQuestionTrigger: node.isQuestionTrigger,
  choices: node.choices,
  statements: node.statements,
  type: node.type,
  range: node.range,
  input: node.input,
  outputs: node.outputs,
  position: node.position,
  reportOrder: node.reportOrder,
  commentGroupId: node.commentGroupId,
});

export const diffNodeDataGraph = (before: NodeData[], after: NodeData[]): TopicGraphDiff =>
  diffTopicGraph(before.map(nodeDataToTopicGraphNode), after.map(nodeDataToTopicGraphNode));

export const clearAiDiffHighlights = async (editor: CustomNodeEditor): Promise<void> => {
  await Promise.all(
    editor.getNodes().map(async (node) => {
      if (!node.data.aiDiffStatus) {
        return;
      }
      delete node.data.aiDiffStatus;
      await editor.areaPlugin.update('node', node.id);
    }),
  );
};

export const applyAiDiffHighlights = async (editor: CustomNodeEditor, diff: TopicGraphDiff): Promise<void> => {
  const statusByIndex = new Map<number, AiDiffStatus>();
  diff.added.forEach((index) => statusByIndex.set(index, 'added'));
  diff.modified.forEach((index) => statusByIndex.set(index, 'modified'));

  await Promise.all(
    editor.getNodes().map(async (node) => {
      const status = statusByIndex.get(node.data.questionIndex);
      if (status) {
        node.data.aiDiffStatus = status;
      } else {
        delete node.data.aiDiffStatus;
      }
      await editor.areaPlugin.update('node', node.id);
    }),
  );
};
